import * as React from "react";
import { CostOfCareCalculatorContext } from "./context/CostOfCareCalculatorState";
import { CocSuburbAutocomplete } from "./CocSuburbAutocomplete";

export const InputComponent = () => {

    const { state } = React.useContext(CostOfCareCalculatorContext)

    let average = state.model?.nationalAverageAmount % Math.floor(state.model?.nationalAverageAmount) > 0 ? state.model?.nationalAverageAmount.toFixed(2) : state.model?.nationalAverageAmount

    return (
        <React.Fragment>
            <div className="lg:w-1/2">
                <div className="mb-4">
                    <span className="text-xl font-bold">How much could my child care cost?</span>
                </div>

                {/*Post Code Input*/}
                <div className="mb-4">
                    <div className="flex flex-row items-center gap-4">
                        <div className="text-11p sm:text-xs md:text-base-15">LOCATION</div>
                        {state.loading &&
                            <div className="flex flex-row items-center gap-2">
                                <img src="/img/navy-spinner.svg" alt="spinner" /><span className="text-xs md:text-base-15">Calculating...</span>
                            </div>
                        }
                    </div>
                    <div className="mt-1 relative rounded-md">
                        <CocSuburbAutocomplete />
                    </div>
                </div>

                {/*National Daily Average*/}
                {!state.hasResults &&
                    <div className="w-full flex flex-col justify-between bg-skin-site-header border border-skin-neutral-light rounded-lg p-3">
                        <div className="mb-2 text-11p sm:text-xs md:text-base-15">NATIONAL DAILY AVERAGE</div>
                        <div className="mb-4 text-3xl font-bold">${average}</div>
                        <div className="text-base-15 text-skin-grey">
                            Before subsidies
                        </div>
                    </div>
                }
                
            </div>
        </React.Fragment>
    );
}